import { Link } from "react-router-dom";

const zones = [
  {
    title: "角色解析",
    desc: "亚梦、几斗、歌呗与守护者们的心路历程。",
    icon: "ri-user-heart-line",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    title: "设定解析",
    desc: "守护蛋、X 蛋与守护甜心的世界观设定。",
    icon: "ri-puzzle-line",
    tone: "bg-secondary-100 text-secondary-800",
  },
  {
    title: "结局解析",
    desc: "从结局与时间线读懂每位角色的最终归宿。",
    icon: "ri-flag-2-line",
    tone: "bg-accent-100 text-accent-800",
  },
  {
    title: "影评随想",
    desc: "聊聊守护甜心为何成为童年的白月光。",
    icon: "ri-quill-pen-line",
    tone: "bg-primary-100 text-primary-700",
  },
];

export default function ThemeZones() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
      <div className="text-center">
        <p className="text-sm text-primary-600 font-medium">主题专区</p>
        <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">按你关心的方向去看</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-foreground-700">
          无论是想搞懂设定、重温角色，还是想一次看清结局，都有对应的专题文章等着你。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {zones.map((z) => (
          <Link
            key={z.title}
            to="/analysis"
            className="group rounded-2xl border border-background-200/70 bg-background-50 p-6 transition-colors hover:border-primary-200"
          >
            <span
              className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${z.tone} transition-transform group-hover:-translate-y-1`}
            >
              <i className={z.icon} />
            </span>
            <h3 className="mt-4 font-display text-xl text-foreground-950">{z.title}</h3>
            <p className="mt-2 text-sm leading-6 text-foreground-700">{z.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600">
              去阅读 <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}